import { render } from "./profilDinas.vue?vue&type=template&id=42a21d6c"
import script from "./profilDinas.vue?vue&type=script&lang=js"
export * from "./profilDinas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__